import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DoneIcon from '@mui/icons-material/Done';
import Tooltip from '@mui/material/Tooltip';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';

import classes from './CourseProgress.module.css';

const CourseProgress = props => {
  const { t } = useTranslation(['course']);

  return (
    <>
      {props.activityState === 'finished' ? (
        <Tooltip title={t('finished')}>
          <DoneIcon className={classes.doneIcon} />
        </Tooltip>
      ) : props.activityState === 'started' ? (
        <Tooltip title={t('started')}>
          <div
            className={`${
              props.icon !== 'lesson'
                ? classes.wrapper
                : classes.wrapperSpecial
            }`}
          >
            <div className={classes.one}></div>
          </div>
        </Tooltip>
      ) : (
        <Tooltip title={t('without_starting')}>
          <div
            className={`${
              props.icon !== 'lesson'
                ? classes.wrapper
                : classes.wrapperSpecial
            }`}
          >
            <div className={classes.oneNoInit}></div>
          </div>
        </Tooltip>
      )}
      {props.icon !== 'lesson' ? (
        <figure className={classes.iconLessonContainer}>
          <img
            className={classes.img}
            src={
              props.icon === 'video'
                ? 'https://d1g6c01s9ssd7h.cloudfront.net/img/Video_icon.png'
                : props.icon === 'quiz'
                ? 'https://d1g6c01s9ssd7h.cloudfront.net/img/Evaluacion_icon.png'
                : props.icon === 'activity'
                ? 'https://d1g6c01s9ssd7h.cloudfront.net/img/Actividad_icon.png'
                : props.icon === 'audio'
                ? 'https://d1g6c01s9ssd7h.cloudfront.net/img/Actividad_icon.png'
                : 'https://d1g6c01s9ssd7h.cloudfront.net/img/Coevaluacion_icon.png'
            }
          />
        </figure>
      ) : (
        <div className={classes.iconLessonContainerSpecial}>
          <ArticleOutlinedIcon className={classes.iconLesson} />
        </div>
      )}
    </>
  );
};

CourseProgress.propTypes = {
  // eslint-disable-next-line react/require-default-props
  activityState: PropTypes.string,
  // eslint-disable-next-line react/require-default-props
  icon: PropTypes.string
};

export default CourseProgress;
